import { Property } from "csstype";
import { CSSProperties } from "react";

type Props = CSSProperties & {
  children?: React.ReactNode;
  direction?: Property.FlexDirection | undefined;
  gap?: string | number;
  justifyContent?: string;
  alignItems?: string;
  flex?: number;
  display?: string;
  padding?: string | number;
};
export const Flex = ({
  children,
  direction,
  flexDirection,
  gap,
  justifyContent,
  alignItems,
  flex,
  display = "flex",
  padding,
  ...styles
}: Props) => {
  return (
    <div
      style={{
        ...styles,
        padding,
        display: display,
        flexDirection: direction || flexDirection,
        gap,
        justifyContent,
        alignItems,
        flex,
      }}
    >
      {children}
    </div>
  );
};
